import React, { useCallback, useRef } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { get } from 'lodash-es';
import { ScrollLink } from 'site-modules/shared/components/scroll-link/scroll-link';

import './anchor-sub-navigation.scss';

export function AnchorSubNavigation({ list = null, customOffset = 0, hasBubblesDesign = false, idName = 'subnav' }) {
  const navbarRef = useRef();

  /**
   * Calculates and makes link centered every time it's chosen as active
   */
  const handleSetActive = useCallback(currentHash => {
    const navbar = navbarRef.current;
    const currentLink = navbar && navbar.querySelector(`[href="#${currentHash}"]`);
    if (!navbar || !currentLink) {
      return;
    }

    const centerStart = navbar.clientWidth / 2 - currentLink.clientWidth / 2;
    navbar.scrollLeft = Math.max(0, currentLink.offsetLeft - centerStart);
  }, []);

  if (!get(list, 'length')) {
    return null;
  }

  return (
    <div className="anchor-sub-navigation" data-tracking-parent="edm-entry-subnav">
      <nav
        className="navbar row p-0 text-nowrap heading-6 fw-normal"
        id={idName}
        ref={navbarRef}
        aria-label="Features for cars comparision"
      >
        <ul
          className={classnames('list-unstyled text-start', { 'my-1': hasBubblesDesign, 'mb-0': !hasBubblesDesign })}
          data-tracking-id="view_content"
        >
          {list.map(({ name, hash }) => (
            <li
              key={name}
              className={classnames('d-inline-block nav-item', {
                'px-0_25': hasBubblesDesign,
                'px-0_5 px-xl-0_75': !hasBubblesDesign,
              })}
            >
              <ScrollLink
                spy
                to={hash}
                activeClass={classnames('link-active', { 'text-primary-darker': !hasBubblesDesign })}
                scrollConfig={{ offset: -customOffset }}
                className={classnames('d-inline-block text-nowrap', {
                  'bubble size-14 py-0_5 px-0_75': hasBubblesDesign,
                  'sub-navigation-link py-0_75': !hasBubblesDesign,
                })}
                data-tracking-value={name}
                onSetActive={handleSetActive}
                rel="nofollow"
              >
                {name}
              </ScrollLink>
            </li>
          ))}
        </ul>
      </nav>
      <hr className="row my-0 mx-lg-0 mx-xl-0_25" />
    </div>
  );
}

AnchorSubNavigation.propTypes = {
  list: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string.isRequired,
      hash: PropTypes.string,
    })
  ),
  customOffset: PropTypes.number,
  hasBubblesDesign: PropTypes.bool,
  idName: PropTypes.string,
};
